import React from "react";
import Icon from "../Icon";

export default props => (
  <Icon viewBox="0 0 32 32" {...props}>
    <path
      d="M16 16a4 4 0 100-8 4 4 0 000 8zm0 14c6-6 10-12.477 10-18S21.523 2 16 2 6 6.477 6 12s4 12 10 18z"
      fill="none"
    />
  </Icon>
);
